import ForgotPasswordPage from "./components/forgot-password/ForgotPasswordPage";
import "./styles/Auth.module.css";

const ForgotPassword = () => {
  return (
    <div className="auth-container">
      <div className="auth-form">
        <ForgotPasswordPage />
      </div>
    </div>
  );
};

export default ForgotPassword;
